import { createAdminClient } from '@beatq/sdk';
import { csrfHeaders, getAccessToken } from '@beatq/shared';
import { getApiBaseUrl } from './config.js';
export function getAdminClient() {
    return createAdminClient({
        baseUrl: getApiBaseUrl(),
        credentials: 'include',
        accessToken: getAccessToken() ?? undefined,
        headers: csrfHeaders(),
    });
}
//# sourceMappingURL=admin.js.map